<template>
    <div class="container">
        <div class="header">会员注册协议</div>
        <div class="content">
            <p>“金穗智管服务平台”为天津远景网络科技有限公司运营的新经济综合服务平台，上述会员自签署本协议即注册成为本平台会员，自愿受本协议条款约束。本平台有权修改本协议正文及相关规则，修改内容将在实施前七日在本平台予以公示。如会员不同意相关修改，应当停止使用并退出本平台，不影响协议修改前已发生义务及责任的承担。一旦会员继续使用本平台，则表示已接受并自愿遵守经修订后的条款。</p>

            <div class="sub-title"><span class="ui-interval">第一条</span>会员资格</div>
            <p>
                <span class="ui-interval">1.1</span>符合下列条件之一的，方可申请注册成为本平台会员：
                <br>
                （1）依据中国法律成立并有效存续的企业法人；
                <br>
                （2）具有完全民事行为能力的独立从事生产经营的个人，且不得有任何与本平台建立劳动关系或雇佣关系的意向。
                <br>
                不具备上述条件而注册为本平台会员的，本平台一经发现，有权立即注销该会员，给本平台造成损失的，应当按照本协议违约责任条款予以赔偿。
            </p>
            <p>
                <span class="ui-interval">1.2</span>会员应当向本平台提供真实准确的注册信息，包括但不限于名称或姓名、联系地址、联系人、联系电话、电子邮箱及统一社会信用代码或居民身份证号码，并根据本平台要求上传相关证照及有关文件，保证本平台可以通过注册信息与会员取得联系。同时，会员也应当在相关资料实际变更时及时更新有关注册资料。
            </p>

            <div class="sub-title"><span class="ui-interval">第二条</span>会员权利与义务</div>
            <p>
                <span class="ui-interval">2.1</span>会员不得利用本平台危害国家安全、泄露国家秘密，不得利用本平台制作、发布和传播下列信息：
                <br>
                （1）煽动抗拒、破坏宪法、法律和行政法规实施的；
                <br>
                （2）煽动颠覆国家政权、推翻社会主义制度的；
                <br>
                （3）煽动分裂国家、破坏国家统一的；
                <br>
                （4）宣扬民族仇恨、民族歧视，破坏民族团结的；
                <br>
                （5）宣扬恐怖主义、极端主义的；
                <br>
                （6）编造虚假信息或者歪曲事实，散布谣言，扰乱经济秩序和社会秩序的；
                <br>
                （7）宣扬封建迷信、淫秽、色情、暴力信息，教唆犯罪的；
                <br>
                （8）侵害他人名誉、隐私、知识产权和其他合法权益的；
                <br>
                （9）进行商业广告行为的。
            </p>
            <p>
                <span class="ui-interval">2.2</span>会员应妥善保管在本平台上注册的代表其本人身份的账户及其密码，会员有权根据需要更改其账户密码。会员须对其账号密码下发生的所有活动（包括但不限于网上点击同意各类协议、规则、表单，发布需求或提供服务等）承担责任。在会员账号和密码被本平台系统识别正确的前提下进行的业务操作均视为会员本人或其合法授权人进行的操作。
            </p>
            <p>
                <span class="ui-interval">2.3</span>会员不得擅自以任何形式转让在本平台的会员帐号。如会员发现有他人冒用、盗用或未经授权使用其账户，应及时向本平台挂失，并按照本平台规定办理相关手续，本平台将采取必要措施予以配合。
            </p>
            <p>
                <span class="ui-interval">2.4</span>会员有权根据本协议及本平台发布的相关规则获取或提供服务，参加本平台的有关活动并享受本平台提供的其他有关资讯及信息服务。
            </p>
            <p>
                <span class="ui-interval">2.5</span>会员有义务确保在本平台上发布的信息真实、准确，在本平台交易应当遵守诚实信用原则，不得以干预、操纵发布或提供服务等不正当竞争方式扰乱网上交易秩序，不得从事与平台交易无关的不当行为。
            </p>
            <p>
                <span class="ui-interval">2.6</span>会员保证使用本平台实施的所有行为遵守法律、法规、行政规章和本平台的相关规则，不得危害网络安全，不得利用本平台侵犯国家、社会公共利益和公民的合法权益，如有违反导致任何法律后果，会员将自行独立承担相应的法律责任。
            </p>
            <p>
                <span class="ui-interval">2.7</span>会员同意接收来自本平台的信息，包括但不限于服务信息、系统信息等。未经本平台书面允许，会员不得将本平台的任何资料以及本平台上所展示的任何信息作商业性利用。
            </p>

            <div class="sub-title"><span class="ui-interval">第三条</span>平台权利与义务</div>
            <p>
                <span class="ui-interval">3.1</span>本平台有义务在现有技术水平的基础上努力维护网上平台的正常运行，尽力避免服务中断或将中断时间限制在最短时间内。
            </p>
            <p>
                <span class="ui-interval">3.2</span>本平台有义务对会员在注册、使用本平台中所提出的有关问题或反映的相关情况及时作出回复。
            </p>
            <p>
                <span class="ui-interval">3.3</span>本平台有权对会员的注册资料进行审查，对存在任何问题或怀疑的注册资料，本平台有权发出通知询问会员并要求会员做出解释、改正。
            </p>
            <p>
                <span class="ui-interval">3.4</span>根据本平台所掌握的事实依据可以认定会员存在违法或违反本协议行为，本平台有权以平台发布形式公布该会员的违法或违约行为，并有权作出删除相关信息、终止服务等处理。
            </p>
            <p>
                <span class="ui-interval">3.5</span>本平台对黑客攻击、网络病毒、银行系统故障、电信部门技术调整及线路故障导致的影响、因政府管制造成的暂时性关闭、电力系统故障或限制性供电等在内的任何影响网络正常经营的情形不承担责任，平台与会员应积极协调处理善后事宜。
            </p>
            <p>
                <span class="ui-interval">3.6</span>本平台提供的与互联网上其他平台或资源的链接，不表示本平台与该等运营商有任何关系。其它运营商经营的平台均由各经营者自行负责，不属于本平台控制及负责范围之内。对于存在或来源于此类平台或资源的任何内容、广告、物品或其它资料，本平台亦不予保证或负责。因使用或依赖任何此类平台或资源发布的或经由此类平台或资源获得的任何内容、物品或服务所产生的任何损害，本平台不负任何直接或间接的责任。
            </p>
            <p>
                <span class="ui-interval">3.7</span>本平台部分或全部功能因故无法使用的，基于本平台的交易可通过线下方式完成，本平台不因此而承担任何违约责任。
            </p>

            <div class="sub-title"><span class="ui-interval">第四条</span>知识产权</div>
            <p>
                <span class="ui-interval">4.1</span>本平台及本平台所使用的相关软件、程序、内容，包括但不限于文字、图片、视频、档案、资料、平台架构、平台版面的安排、网页设计、经由本平台或广告商向会员呈现的广告或资讯，均由本平台或其他权利人依法享有相应的知识产权，包括但不限于著作权及与著作权有关的权利、商标权、专利权及其它专属权利，未经本平台或权利人许可不得使用，会员保证不侵犯上述知识产权。
            </p>
            <p>
                <span class="ui-interval">4.2</span>会员不得经由非本平台所提供的界面使用本平台。
            </p>
            <div class="sub-title"><span class="ui-interval">第五条</span>商业秘密</div>
            <p>
                <span class="ui-interval">5.1</span>会员不得以下列手段侵犯本平台或其他会员的商业秘密：
                <br>（1）以不正当手段获取上述商业秘密；
                <br>（2）披露、使用或允许他人使用以不正当手段获取的上述商业秘密；
                <br>（3）披露、使用或允许他人使用因签署履行本协议或在本平台交易所掌握的上述商业秘密。
                <br>本平台亦不得以上述手段侵犯会员的商业秘密。
            </p>
            <p>
                <span class="ui-interval">5.2</span>上述保密义务不因本协议的终止而解除。
            </p>
            <p>
                <span class="ui-interval">5.3</span>本协议所称商业秘密，是指不为公众所知悉、能为权利人带来经济利益、具有实用性并经权利人采取保密措施的技术信息和经营信息。
            </p>

            <div class="sub-title"><span class="ui-interval">第六条</span>会员信息使用</div>
            <p>
                <span class="ui-interval">6.1</span>除非本协议约定或事先得到会员许可，本平台不使用、披露任何会员的非公开信息，任何会员也不得使用、披露其在本平台获取或提供服务而知悉的其他会员的非公开信息。
            </p>
            <p>
                <span class="ui-interval">6.2</span>会员的非公开信息将在下述情况下部分或全部被披露：
                <br>（1）经会员同意，向第三方披露；
                <br>（2）根据法律、法规、行政规章的有关规定，或者行政、司法机关的要求；
                <br>（3）会员出现违反法律法规规章、违反本协议的情况，本平台向第三方披露；
                <br>（4）会员基于本平台发布服务需求或提供服务，本平台需向第三方披露；
                <br>（5）其他本平台根据法律法规规章或者平台规则认为合适的披露。
            </p>

            <div class="sub-title"><span class="ui-interval">第七条</span>服务的终止</div>
            <p>
                <span class="ui-interval">7.1</span>本平台有权自行决定终止对会员的部分或全部服务，并有权在终止服务后三年内保存会员在本平台的全部资料（包括但不限于会员信息、交易信息等）。
            </p>
            <p>
                <span class="ui-interval">7.2</span>会员向本平台提出注销本平台注册会员身份的，需经本平台审核同意，由本平台注销会员身份，会员即解除与本平台的协议关系，但本平台仍保留下列权利：
                <br>（1）会员注销后，本平台有权在法律、法规、行政规章规定或本协议约定的期限内保留该会员的资料,包括但不限于以前的会员资料、交易记录等。
                <br>（2）若会员注销前有违反本协议的行为，会员注销后本平台仍可行使本协议所约定的权利。
            </p>
            <p>
                <span class="ui-interval">7.3</span>会员存在下列情形之一的，本平台可以通过注销会员的方式终止服务：
                <br>（1）会员违反本协议约定的；
                <br>（2）本平台发现会员注册资料中有虚假内容的；
                <br>（3）本协议终止或更新时，会员未确认新的协议的。
            </p>
            <p>
                <span class="ui-interval">7.4</span>服务终止后，本平台无义务为会员保留原账户中及与之相关的任何信息，或转发任何未曾阅读或发送的信息给会员或第三方。
            </p>

            <div class="sub-title"><span class="ui-interval">第八条</span>违约责任</div>
            <p>本平台和会员任何一方有违约行为的，应向对方承担违约责任，赔偿因此给对方造成的全部损失，对方通过诉讼或其他方式主张权利的费用（包括但不限于合理的诉讼费、律师费、公证费、调查费、鉴定评估费、交通费、食宿费、差旅费等）应计入损失范围。</p>

            <div class="sub-title"><span class="ui-interval">第九条</span>通知与送达</div>
            <p>
                <span class="ui-interval">9.1</span>本平台根据本协议需要向会员发出的通知或其他文件，应当按照本平台相关规则，采用本平台系统线上发送，或按照会员注册信息中的联系方式，选择电子邮件、当面递交或公认的快递服务发送。
            </p>
            <p>
                <span class="ui-interval">9.2</span>会员根据本协议需要向本平台发出的通知或其他文件，应当按照本平台相关规则，采用本平台系统线上发送，或按照本平台上公告的客服信息，选择电子邮件、当面递交或公认的快递服务发送。
            </p>
            <p>
                <span class="ui-interval">9.3</span>根据以上约定，采用本平台系统线上发送的，成功发送当日视为送达；采用电子邮件发送的，电子邮件成功发送当日视为送达；当面递交的，递交当日视为送达；采用公认的快递服务发送的，交寄后第3日视为送达。
            </p>

            <div class="sub-title"><span class="ui-interval">第十条</span>争议解决方式</div>
            <p>
                <span class="ui-interval">10.1</span>本协议的订立、效力、解释、履行和争议解决等均适用中华人民共和国法律。
            </p>
            <p>
                <span class="ui-interval">10.2</span>如本协议履行中发生争议，应首先协商解决，协商解决不成的，任一方均可向平台方住所地有管辖权的人民法院提起诉讼。在争议解决期间，本协议不涉及争议部分的条款仍须履行。
            </p>

            <div class="sub-title"><span class="ui-interval">第十一条</span>附则</div>
            <p>
                <span class="ui-interval">11.1</span>在本协议中所使用的下列词语，除非另有定义，应具有以下含义：
                <br>“本平台”：指“金穗智管服务平台”（https://service.jinsuizhiguan.com），经营者天津远景网络科技有限公司享有并承担本协议项下本平台的所有权利和义务。
                <br>“会员”：指与本平台签订《会员注册协议》并完成注册流程的企业或个人。
                <br>“本协议”：包括本协议正文及附件。
            </p>
            <p>
                <span class="ui-interval">11.2</span>对于企业会员，本平台在本协议签署后提供会员账户及初始登录密码，企业会员应当在第一次登录时修改账户登录密码并自主设置支付密码。
            </p>
            <p>
                <span class="ui-interval">11.3</span>对于企业会员，《会员注册协议》内容包括协议正文及《企业会员外包服务规则》；对于个人会员，《会员注册协议》内容包括协议正文及《个人会员分包服务规则》。
            </p>
            <p><br>以下无正文。<br></p>
        </div>
        <div class="header">企业会员外包服务规则</div>
        <div class="content">
            <p>本平台作为新经济综合服务平台，企业会员可将经营所需灵活、零星的服务项目外包给本平台，在本平台予以发布，本平台承接后可选择自行完成其中的一项或多项任务，也可将其中的一项或多项任务进行再分包，再分包方为本平台遴选并经该企业会员确认的个人会员。本平台亦可将其中的一项或多项任务转包给本平台的相关运营方。</p>

            <div class="sub-title"><span class="ui-interval">第一条</span>服务项目清单</div>
            <p>
                <span class="ui-interval">1.1</span>具有外包服务需求的企业会员可通过会员系统自主填写《服务需求项目清单》，该清单应包括目前需求以及将来可预见需求的服务项目。
            </p>
            <p>
                <span class="ui-interval">1.2</span>《服务需求项目清单》格式以系统设置为准，包括服务需求项目的类别、内容、单位以及服务要求。
            </p>
            <p>
                <span class="ui-interval">1.3</span>服务需求项目的描述应当准确、完整，一项服务内容只能包括一项具体事务，不同类型的事务不得合并为一项服务内容。
            </p>
            <p>
                <span class="ui-interval">1.4</span>《服务需求项目清单》中的“服务要求”由企业会员区分不同项目自主设置其内容，包括但不限于具体项目的业务规范、完成时限、服务成果的描述以及奖惩规则等。
            </p>
            <p>
                <span class="ui-interval">1.5</span>企业会员完成《服务需求项目清单》填写后向本平台系统提交，本平台依据相关法律规定、协议约定及自身实际情况审核是否具备承接的可能性。
            </p>
            <p>
                <span class="ui-interval">1.6</span>对于本平台经审核确认的企业会员《服务需求项目清单》，企业会员可随时根据经营需要勾选其中的一项或多项发布服务需求。
            </p>
            <p>
                <span class="ui-interval">1.7</span>企业会员如需变更《服务需求项目清单》，应当按照上述程序通过本平台重新审核。
            </p>
            <p>
                <span class="ui-interval">1.8</span>在本平台已详细了解企业会员服务需求的情况下，亦可代为填写《服务需求项目清单》供企业会员确认，企业会员实际使用本平台提供的《服务需求项目清单》视为已确认该清单内容。
            </p>

            <div class="sub-title"><span class="ui-interval">第二条</span>任务的生成</div>
            <p>
                <span class="ui-interval">2.1</span>企业会员可在本平台系统确认的《服务需求项目清单》中勾选“服务内容”生成《服务需求发布单》，向本平台提交《服务需求发布单》。
            </p>
            <p>
                <span class="ui-interval">2.2</span>本平台承接企业会员《服务需求发布单》的，由本平台结合企业会员方的具体需求和地域特点，本平台可选择自行完成其中的一项或多项任务，也可将其中的一项或多项任务进行再分包，再分包方为本平台遴选并经该企业会员确认的个人会员。本平台亦可将其中的一项或多项任务转包给本平台的相关运营方。
            </p>
            <p>
                <span class="ui-interval">2.3</span>本平台选择自行完成企业会员《服务需求发布单》中的服务内容的，直接通过本平台系统向该企业会员发送《服务需求确认单》，任务生成。
            </p>
            <p>
                <span class="ui-interval">2.4</span>本平台需将企业会员《服务需求发布单》中的服务内容分包的，应当以拟分包的个人会员为单位拆分生成《服务需求确认单》予以发送，经该企业会员及拟分包的个人会员确认后任务生成。会员根据本平台系统设置选择确认方式。
            </p>
            <p>
                <span class="ui-interval">2.5</span>提交《服务需求发布单》的企业会员对本平台拟分包的个人会员有考察要求的，本平台应当予以配合（包括但不限于提交该个人会员在本平台的注册信息），该个人会员有如下情形之一的，企业会员不得确认相应的《服务需求确认单》：
                <br>（1）与该企业会员具有劳动/劳务合同关系或其他类似法律关系的人员；
                <br>（2）该企业会员或其关联方的法定代表人、董事、监事、股东；
                <br>（3）该企业会员经考察认为其不具备相应分包能力的。
            </p>
            <p>
                <span class="ui-interval">2.6</span>企业会员《服务需求发布单》中的一项或多项服务内容，在向本平台提交后<span class="underline letter-2"></span>日内仍未生成任务的，该服务内容自动取消。
            </p>
            <p>
                <span class="ui-interval">2.7</span>任务生成后，相关方方可按照《服务需求确认单》实施任务。除非基于法律明确规定或本规则明确规定的事由，发包会员不得单方中止、终止已生成的任务。
            </p>

            <div class="sub-title"><span class="ui-interval">第三条</span>任务的实施</div>
            <p>
                <span class="ui-interval">3.1</span>已生成的任务，除非本规则另有规定，相关方均应按照本平台《服务需求确认单》所载的服务要求实施。如发包会员提出《服务需求确认单》未明确约定的要求，本平台或其分包会员有权拒绝，发包会员不得以此为由拒绝服务成果。
            </p>
            <p>
                <span class="ui-interval">3.2</span>本平台分包的任务，由分包会员直接向发包会员提供服务并输出服务成果，由发包会员直接进行确认，视为本平台向发包会员的实际交付。
            </p>
            <p>
                <span class="ui-interval">3.3</span>如发包会员与分包会员在《服务需求确认单》的任务之外另有服务或其他约定安排的，本平台不就未参与的安排承担任何责任。
            </p>
            <p>
                <span class="ui-interval">3.4</span>任务实施完毕，本平台或其分包会员向发包会员提交服务成果。《服务需求确认单》中各项任务的服务成果，可总体提交，也可逐项或多项一并提交。
            </p>
            <p>
                <span class="ui-interval">3.5</span>本平台或其分包会员提交的服务成果，符合下列条件之一的，发包会员应当于该项服务成果提交之日二日内按照系统格式向本平台提交《服务成果确认书》，视为任务完成：
                <br>（1）服务成果符合本平台《服务需求确认单》中该项任务的服务要求。
                <br>（2）不论是否符合《服务需求确认单》中该项任务的服务要求，发包会员同意接受的。本平台将于收到发包会员提交的《服务成果确认书》后二日内转发分包会员。
            </p>
            <p>
                <span class="ui-interval">3.6</span>分包会员向发包会员提交服务成果后，发包会员未按约定期限向本平台提交《服务成果确认书》的，本平台有权根据分包会员提出的相关证明材料要求发包会员做出说明，发包会员应当于三日内向本平台提交书面说明，与分包会员对服务成果有争议的，按照异议解决条款处理。
            </p>
            <p>
                <span class="ui-interval">3.7</span>在分包会员任务实施过程中，发包会员应充分认识到其独立服务商的性质，不应对其适用员工管理制度，否则由此导致分包会员主张相关权利的，发包会员承担相关的法律责任。
            </p>
            <p>
                <span class="ui-interval">3.8</span>发包会员未按照本规则履行义务，导致分包会员向本平台主张权利的，发包会员应当立即采取补救措施予以解决，给本平台造成损失的按照《会员注册协议》中的违约责任条款予以赔偿。发包会员未按照本规则履行义务导致本平台向分包会员承担责任的，应当按照《会员注册协议》中的违约责任条款赔偿由此给本平台造成的全部损失。
            </p>

            <div class="sub-title"><span class="ui-interval">第四条</span>任务的费用</div>
            <p>
                <span class="ui-interval">4.1</span>发包会员应当按照本规则的规定支付任务的服务费用，服务费用包括两部分：
                <br>（1）任务的服务报酬，计价方式载于《服务需求确认单》；
                <br>（2）平台的综合服务费，计价方式为任务服务报酬的9.5%。
            </p>
            <p>
                <span class="ui-interval">4.2</span>服务报酬的结算金额以发包会员、分包会员均予确认的《服务成果确认书》内容为准（如与服务需求确认单中计价不一致的，以上述《服务成果确认书》为准）。发包会员应当于提交《服务成果确认书》前足额预付服务费用。服务费用以银行转账方式向本平台支付。
            </p>
            <p>
                <span class="ui-interval">4.3</span>发包会员或分包会员对《服务成果确认书》中的结算内容不认可的，视为结算异议。部分任务有结算异议的，不影响无结算异议部分任务的结算。
            </p>
            <p>
                <span class="ui-interval">4.4</span>对于已经确认或默认结算的服务费用，本平台根据结算任务的具体内容及结算金额，根据税法规定开具相应的增值税发票。企业会员应当于注册时提交准确、完整的增值税开票信息。
            </p>
            <p>
                <span class="ui-interval">4.5</span>已生成的任务因故未完成的，按照已经完成的工作量占任务总体工作量的比例结算服务费用。任务未完成是可归责于一方原因造成的，由责任方另行承担违约责任。
            </p>
            <p>
                <span class="ui-interval">4.6</span>本平台与发包会员完成服务费用结算后，向分包会员支付相应的分包服务报酬。发包会员向分包会员直接支付的任何款项与本平台无关，不能构成本规则项下任何服务费用的支付。
            </p>

            <div class="sub-title"><span class="ui-interval">第五条</span>异议的解决</div>
            <p>
                <span class="ui-interval">5.1</span>发包会员或分包会员对于服务成果或结算依据本规则提出的有效异议，由本平台客服专员与任务的相关各方沟通解决，如自异议提出之日起七日内仍未能达成一致的，则本平台对于异议涉及的任务在线上予以关闭封存，转由线下解决。
            </p>
            <p>
                <span class="ui-interval">5.2</span>上述异议转由线下解决的，如相关方经协商就异议解决达成一致，可于线下签署有关协议；经协商仍不能达成一致的，按照《会员注册协议》约定的争议解决方式处理。
            </p>

            <div class="sub-title"><span class="ui-interval">第六条</span>任务的中止与取消</div>
            <p>
                <span class="ui-interval">6.1</span>分包会员在任务实施中有下列情形之一的，发包会员有权中止该任务：
                <br>（1）严重违反《服务需求确认单》中的服务要求的；
                <br>（2）故意或重大过失给发包会员造成重大损害的；
                <br>（3）与其他单位存在劳动关系，影响为发包会员提供服务；
                <br>（4）因犯罪被追究法律责任的；
                <br>（5）不能胜任任务，明确表示或有证据表明其无法提交符合约定的服务成果的；
                <br>（6）双方约定的其他情形。
                <br>发包会员基于上述情形中止相应任务的，有权选择要求本平台更换分包会员或直接取消相应任务。选择更换分包会员的，双方互相配合于七日内完成更换并恢复任务，中止期间不计入服务时限；直接取消相应任务的，不构成本平台违约。
            </p>
            <p>
                <span class="ui-interval">6.2</span>发包会员有以下行为之一的构成违约，本平台有权取消违约行为涉及的任务：
                <br>（1）与分包会员串通损害本平台利益的；
                <br>（2）未能按时支付服务费用的；
                <br>（3）未提供任务实施所必需的条件的；
                <br>（4）要求分包会员从事违反法律法规或有害公序良俗的行为；
                <br>（5）要求分包会员进行危及人身安全的作业；
                <br>（6）宣传过失，给本平台造成严重负面影响，致使本平台社会评价严重下降。
            </p>
            <p>
                <span class="ui-interval">6.3</span>分包会员出于自身原因提出无法继续实施任务，本平台提前七日通知发包会员的，不视为本平台违约，发包方有权选择要求本平台更换分包会员或直接取消相应任务：选择更换分包会员的，双方互相配合于上述提前通知期内完成更换；直接取消相应任务的，不构成本平台违约。
            </p>

            <div class="sub-title"><span class="ui-interval">第七条</span>附则</div>
            <p>
                <span class="ui-interval">7.1</span>本规则下列用语的定义：
                <br>（1）“发包会员”：指将向本平台外包任务，本平台自行或以分包方式承接其任务的企业会员。
                <br>（2）“分包会员”：指本平台将所承接的任务分包，承接本平台分包任务的个人会员。
                <br>（3）“任务”指企业会员外包给本平台的《服务需求确认单》中的服务内容或本平台分包给个人会员的《服务需求确认单》中的服务内容。
            </p>
            <p>
                <span class="ui-interval">7.2</span>下列表单格式作为本规则附件，构成本规则的组成部分：
                <br>（1）《服务需求项目清单》
                <br>（2）《服务需求发布单》；
                <br>（3）《服务需求确认单》；
                <br>（4）《服务成果确认书》。
            </p>
            <p>
                <span class="ui-interval">7.3</span>对于企业会员，本规则作为《会员注册协议》的组成部分，《会员注册协议》正文如与本规则有不一致之处，以本规则规定为准。
            </p>
            <p>
                <span class="ui-interval">7.4</span>企业会员在注册成为本平台会员前已与本平台运营方签署《企业外包服务合同》的，自注册成为本平台会员之日起，上述《企业外包服务合同》解除，相关权利义务按照本平台《会员注册协议》正文及本规则确定，但依据上述《企业外包服务合同》已完成或正在进行的服务项目仍适用上述《企业外包服务合同》。
            </p>
            <p>
                <span class="ui-interval">7.5</span>本规则自本平台公布之日起施行。
            </p>
            <div class="img-box">
                <img src="https://jinsuizhiguan.oss-cn-beijing.aliyuncs.com/assets/enterprise/zg_fj1.png" alt="会员注册协议">
                <img src="https://jinsuizhiguan.oss-cn-beijing.aliyuncs.com/assets/enterprise/zg_fj2.png" alt="会员注册协议">
                <img src="https://jinsuizhiguan.oss-cn-beijing.aliyuncs.com/assets/enterprise/zg_fj3.png" alt="会员注册协议">
                <img src="https://jinsuizhiguan.oss-cn-beijing.aliyuncs.com/assets/enterprise/zg_fj4.jpg" alt="会员注册协议">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Terms',
    mounted () {
        this.$http.get('/api/user/userinfo')
            .then(res => {
                if (res.code === 0) {
                    console.log(res.data)
                } else {
                    this.$message.error(res.message)
                }
            })
            .catch(err => {
                console.log(err)
            })
    }
}
</script>

<style scoped lang="scss">
    .container {
        background-color: #fff;
        padding: 60px 100px;

        .header {
            text-align: center;
            font-size: 20px;
            color: #333;
            font-weight: 600;
            margin-bottom: 35px;
            margin-top: 100px;
            &:first-child {
                margin-top: 0;
            }
        }

        .sub-title {
            margin: 35px 0;
            font-size: 16px;
            font-weight: 600;

            .ui-interval {
                margin-right: 20px;
            }
        }
        .underline {
            display: inline-block;
            border-bottom: 1px solid #666;
            margin: 0 4px;
            &.letter-2 {
                width: 2em;
            }
            &.letter-20 {
                width: 20em;
            }
        }
        p {
            margin-bottom: 0;
            line-height: 2;

            .ui-interval {
                margin-right: 14px;
            }
        }
        .img-box {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            img {
                display: block;
                max-width: 100%;
                height: auto;
                margin: 0 auto;
            }
        }
    }
</style>
